// Payment origin serves to differentiate all the origin of all payments, including the POS ones
// SEE:  https://getslick.atlassian.net/browse/GS-11138

const PAYMENT_ORIGIN_ALL = Object.freeze({
  // Card in-store: group 1
  slickPos: 'slick_pos',
  slickPosRefund: 'slick_pos_refund',
  slickPosDeposit: 'slick_pos_deposit',
  slickPosDepositRefund: 'slick_pos_deposit_refund',
  slickPosVoucher: 'slick_pos_voucher',
  slickPosVoucherRefund: 'slick_pos_voucher_refund',
  tipPos: 'tip_pos',
  tipPosRefund: 'tip_pos_refund',

  // Card online: group 2
  cardOnFile: 'card_on_file',
  cardOnFileRefund: 'card_on_file_refund',
  ncobDeposit: 'ncob_deposit',
  ncobDepositRefund: 'ncob_deposit_refund',
  noShowFee: 'no_show_fee',
  noShowFeeRefund: 'no_show_fee_refund',
  onlineVoucher: 'online_voucher',
  onlineVoucherRefund: 'online_voucher_refund',
  tipOnline: 'tip_online',
  tipOnlineRefund: 'tip_online_refund',

  // Amex/Refund fees: group 3
  amexFee: 'amex_fee',
  refundFee: 'refund_fee',
  disputeFee: 'dispute_fee',
});

export default PAYMENT_ORIGIN_ALL;
